<template>
  <div class="index" v-if="data.style" :style="'position: relative;background-size:100% auto;background-image:url('+oss+data.style.backgroundImage+');background-color:'+data.style.backgroundColor">
    <div class="top_btn">
      <div>活动细则</div>
      <div v-if="data.params.is_show_guide">导购激活</div>
    </div>
    <div class="dm" v-if="data.params&&data.params.is_show_list">
      <img src="@/assets/images/headuser.png" alt="">
      <p> #滚**机# 抽中 微信红包10元</p>
    </div>
    <!-- 大转盘 -->
    <div id="turnTable">
      <div id="lottery" :style="'top:'+(data.style.top/2)+'%'">
        <luckywheel width="310px" height="310px" :blocks="blocks" :prizes="prizes" :buttons="buttons" :default-config="defaultConfig" />
      </div>
    </div>
    <!-- 奖项内容 -->
    <div id="awardContent" v-if="data.params&&data.params.is_show_content">
      <div class="title">
        <img src="@/assets/images/scan/award_title.png" alt="">
        <span>奖项内容</span>
      </div>
      <div class="awardList">
        <div class="awardItem" v-for="(v,k) in prizes" :key="k">
          <img :src="v.item.url" alt="">
          <div>
            <div class="name">{{v.item.name}}</div>
            <div class="des">{{v.item.des}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部按钮 -->
    <div class="footer">
      <div class="award_btn" v-if="data.params&&data.params.showKey.length">
        <div v-if="data.params.showKey.indexOf('store')!=-1"><img src="@/assets/images/scan/store_icon.png" alt=""> 云店商城</div>
        <div v-if="data.params.showKey.indexOf('user')!=-1"><img src="@/assets/images/scan/center_icon.png" alt="">会员中心</div>
      </div>
    </div>

  </div>
</template>

<script>
import config from "@/config";
export default {
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];
    const blocks = [
      {
        padding: "20px",
        background: `#d64737 url('${require("@/assets/images/scan/wheel_bg1.png")}') no-repeat `,
        backgroundSize: "100%",
      },
      { padding: "2px", background: "#C0260F" },
      { background: "radial-gradient(#fff,#FF9C77)", color: "#BA2F23" },
    ];
    const prizes = [
      {
        style: {},
        item: {
          name: "谢谢惠顾",
          url: require("@/assets/images/scan/thanks.png"),
          des: "谢谢惠顾",
        },
      },
      {
        style: {},
        item: {
          name: "一等奖哈哈哈",
          url: require("@/assets/images/scan/jf.png"),
          des: "积分20",
        },
      },
      {
        style: {},
        item: {
          name: "最佳二等奖",
          url: require("@/assets/images/scan/reb.png"),
          des: "100元面值优惠券",
        },
      },
      {
        style: {},
        item: {
          name: "现金券20元",
          url: require("@/assets/images/scan/cut.png"),
          des: "代金券20元",
        },
      },
      {
        style: {},
        item: {
          name: "积分20",
          url: require("@/assets/images/scan/jf.png"),
          des: "积分20",
        },
      },
      {
        style: {},
        item: {
          name: "一等奖",
          url: require("@/assets/images/scan/reb.png"),
          des: "华为 Mate 40 Pro",
        },
      },
      {
        style: {},
        item: {
          name: "二等奖",
          url: require("@/assets/images/scan/lipinfei.png"),
          des: "100元面值优惠券",
        },
      },
      {
        style: {},
        item: {
          name: "最多六个字哦",
          url: require("@/assets/images/scan/coupons.png"),
          des: "100元红包",
        },
      },
    ];
    const buttons = {
      background: `url('${require("@/assets/images/scan/wheel_bg1.png")}')`,
    };
    return {
      oss,
      buttons,
      prizes,
      blocks,
    };
  },
};
</script>

<style lang="less" scoped>
.index {
  width: 337px;
  min-height: 667px;
  background-size: contain;
  padding-bottom: 20px;
  background-repeat: no-repeat;
  .top_btn {
    position: absolute;
    right: 0;
    top: 21px;
    > div {
      width: 80px;
      height: 24px;
      background: rgba(250, 250, 250, 0.6);
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #af1817;
      text-align: center;
      line-height: 24px;
      margin-bottom: 5px;
    }
  }
  .dm {
    position: absolute;
    top: 500px;
    width: 211px;
    height: 30px;
    border-radius: 0px 15px 15px 0px;
    background-color: rgba(250, 250, 250, 0.6);
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #af1817;
    padding-left: 14px;
    img {
      width: 24px;
      height: 24px;
    }
  }
  #turnTable {
    height: 560px;
    display: flex;
    justify-content: center;
    position: relative;
    #lottery {
      position: absolute;
    }
  }
  #awardContent {
    width: 320px;
    margin: 0 auto;
    height: 100%;
    background-color: #fff;
    border-radius: 10px;
    z-index: 1;
    position: relative;
    .title {
      color: #fff;
      text-align: center;
      position: relative;
      width: 100%;
      img {
        width: 135px;
      }
      span {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 16px;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: #ffffff;
      }
    }
    .awardList {
      padding: 10px 14px;
      .awardItem {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        img {
          width: 50px;
          margin-right: 14px;
        }
        .name {
          font-size: 14px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: #ff5f7a;
        }
        .des {
          font-size: 13px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #131212;
        }
      }
    }

  }
      .footer {
      .award_btn {
        width: 320px;
        height: 48px;
        background: #e2152d;
        border-radius: 48px;
        margin: 10px auto;
        display: flex;
        z-index: 1;
        > div:nth-child(2) {
          &::before {
            content: "";
            width: 32px;
            height: 32px;
            background-image: url("../../../../../../../assets/images/scan/line.png");
            background-size: contain;
            background-repeat: no-repeat;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        > div {
          flex: 1;
          text-align: center;
          line-height: 48px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #fee6ac;
          img {
            width: 21px;
            height: 21px;
            margin-right: 10px;
          }
        }
      }
    }
}
</style>